import { render, staticRenderFns } from "./CustomersWOItems.vue?vue&type=template&id=03e23c40&scoped=true"
import script from "./CustomersWOItems.vue?vue&type=script&lang=js"
export * from "./CustomersWOItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e23c40",
  null
  
)

export default component.exports